import React, { useEffect, useState } from "react";
import { Skeleton } from "antd";
import BannersApi from "../../../../api-services/banners-api.service";
import type { Banner } from "../../../../interfaces/banner.interface";
import ScrollCarousel from "./ScrollCarousel";

const bannersApi = new BannersApi();

// "Limited Time Promo" — wide promotional banner cards. Uses the shared
// fixed-width scroll-snap track (like the other sections) so the banners always
// stay on a single row and scroll horizontally, including on mobile.
export default function LimitedTimePromo() {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    bannersApi.getBanners("limited_promo")
      .then(setBanners)
      .catch(() => setBanners([]))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && banners.length === 0) return null;

  return (
    <section className="v2-section" id="limited-promo-v2">
      <h2 className="v2-section__title">Limited Time Promo</h2>
      <ScrollCarousel trackClassName="v2-promo__track" step={396}>
        {loading && [1, 2, 3].map((placeholder) => (
          <div key={placeholder} className="v2-promo-card">
            <Skeleton.Image active />
          </div>
        ))}

        {!loading && banners.map((banner) => {
          const image = (
            <picture>
              <source media="(max-width: 599px)" srcSet={banner.mobileImage || banner.desktopImage} />
              <img src={banner.desktopImage} alt={banner.title || "Promotion"} />
            </picture>
          );

          return (
            <div key={`${banner.title}-${banner.sortOrder}`} className="v2-promo-card">
              {banner.url ? (
                <a href={banner.url} target={banner.target} rel="nofollow">
                  {image}
                </a>
              ) : image}
            </div>
          );
        })}
      </ScrollCarousel>
    </section>
  );
}
